export const getUsersForSelectOption = (users) => {
  return users.map(user => {
    return {
      value: user.id,
      label: `${user.first_name} ${user.last_name}`
    }
  });
}